module.exports = __webpack_public_path__ + "img/logo.ab1453eb.jpg";